<template>
  <dx-facts-form
    next-step-path="PartnerPortal-ReportDamage-DocumentUpload"
    previous-step-path="PartnerPortal-ReportDamage-Info"
    :is-broker="true"
  />
</template>

<script>
import DxFactsForm from '~/components/reportDamage/DX-FactsForm'

export default {
  name: 'PartnerReportDamageFacts',
  components: {
    DxFactsForm,
  },
  layout: 'non-sticky-nav',
  nuxtI18n: {
    paths: {
      de: '/partnerportal/schaden-melden/sachverhalt',
      fr: '/portailpartenaires/dommages-rapport/realites',
      it: '/portaledeipartner/danni-report/fatti',
    },
  },
}
</script>
